import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SizesDropDownDto } from './sizes-drop-down.dto';


export class SizesDropDownResponseModel extends GlobalResponseObject {
    data?: SizesDropDownDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: SizesDropDownDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

